import styled from "styled-components";

export const StyledLink = styled.a`
  text-decoration: underline;
  font-weight: 600;
`

export const StyledSlugInput = styled.div`
  position: relative;

  input {
    padding-left: var(--prefix-offset, 88px) !important;
  }
`

export const StyledPrefixLabel = styled.span`
  font-weight: 600;
  white-space: nowrap;
  color: rgba(51, 51, 51, 0.7);
`
